import React, { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";

import handBookStyles from "pages/HandBook/HandBook.module.scss";
import { HANDBOOK_SHOW_MORE_LIMIT, TEMPLATE_APPLY_EDITINGS_LOADER_TEXT } from "pages/HandBook/const";
import { useCheckAll } from "pages/HandBook/hooks/useCheckAll";
import { HANDBOOK_TEMPLATE_LVL, handBookActions } from "pages/HandBook/model/slice";
import { IHandBookTemplateExpenditure } from "pages/HandBook/model/types";
import TemplateBlurLoader from "pages/HandBook/ui/TemplateBlurLoader/TemplateBlurLoader";
import CreateHandbookTemplateExpenditure from "pages/HandBook/widgets/CreateHandbook/CreateHandbookTemplateExpenditure/CreateHandbookTemplateExpenditure";

import icon from "./../../../../assets/handbook.svg";
import HandBooksTemplateExpenditureRow from "./HandBooksTemplateExpenditureRow";
import { useHandbookTemplateExpenditures } from "./useHandbookTemplateExpenditures";
import { useHandbookTemplatesExpendituresColumns } from "./useHandbookTemplatesExpendituresColumns";
import TableReusableColumnSet from "shared/ui/dataDisplay/TableReusable/TableReusableColumnSet";
import TableReusableHead, { TableReusableHeaderCell } from "shared/ui/dataDisplay/TableReusable/TableReusableHead";
import Checkbox from "shared/ui/inputs/Checkbox/Checkbox";
import BackNavigationBar from "shared/ui/layout/BackNavigationBar/BackNavigationBar";
import ListWrapper from "shared/ui/layout/ListWrapper/ListWrapper";
import RowGrid from "shared/ui/layout/RowGrid/RowGrid";

const HandBooksTemplateExpenditures = () => {
  const {
    hasListFilters,
    isLoading,
    isLoadingMore,
    isEditing,
    total,
    displayExpenditures,
    filter,
    onChangeFilter,
    onPagination,
    onBack,
    currentTemplate,
    currentSection,
    subSectionId,
    currentSubSection,
    segment,
    parentSegment,
    isLoadingApplyEditings,
  } = useHandbookTemplateExpenditures();

  const { allChecked, handleToggleAllChecked } = useCheckAll({
    lvl: HANDBOOK_TEMPLATE_LVL.EXPENDITURES,
    displayItems: displayExpenditures,
  });

  const {
    columns,
    colPercents,
    formColPercents,
    displayColumns,
    toggleColHidden,
    hiddenCols,
    columnsForTableSettings,
  } = useHandbookTemplatesExpendituresColumns({
    isEditing,
  });

  return (
    <>
      <ListWrapper
        data={displayExpenditures}
        dataMapper={(item: IHandBookTemplateExpenditure) => (
          <HandBooksTemplateExpenditureRow
            item={item}
            sectionId={subSectionId ? +subSectionId : item.section_id}
            key={item.id}
            colPercents={colPercents}
            formColPercents={formColPercents}
            columns={displayColumns}
            hiddenCols={hiddenCols}
          />
        )}
        beforeHeader={
          <BackNavigationBar
            onBack={onBack}
            title={currentTemplate?.name || "Шаблоны"}
            slashTitle={
              (currentSection?.name || parentSegment?.name || "") +
              " / " +
              (currentSubSection?.name || segment?.name || "")
            }
            isBold
            className={handBookStyles.backNavigationBar}
          />
        }
        header={
          <TableReusableHead
            isSticky
            isNoDefaultGridCols
            className={isEditing ? handBookStyles.headerWithCheckAll : undefined}
          >
            <RowGrid percents={colPercents}>
              {isEditing && (
                <TableReusableHeaderCell isCentered>
                  <Checkbox onCheck={handleToggleAllChecked} checked={allChecked} noMargin />
                </TableReusableHeaderCell>
              )}
              {displayColumns.map((el) => (
                <TableReusableHeaderCell
                  key={el.header.title}
                  isCentered={el.isCentered}
                  filterType={el.header.filterType ? el.header.filterType : el.header.filterName ? "text" : undefined}
                  filterField={el.header.filterName}
                  onChangeFilter={onChangeFilter}
                  filterTitle={el.header.title}
                  isLast={el.isLast}
                  filterOptions={el.header.filterOptions}
                  filterDefaultValue={el.header.filterName ? filter[el.header.filterName] : undefined}
                  isRighted={el.isRighted}
                  isDebouncedFilterApply
                >
                  {el.header.title}
                </TableReusableHeaderCell>
              ))}
            </RowGrid>
            <TableReusableColumnSet columns={columnsForTableSettings} toggleColHidden={toggleColHidden} />
          </TableReusableHead>
        }
        placeholderProps={{
          img: icon,
          text: hasListFilters || segment ? "Нет сведений" : "Добавьте работы",
          fullHeight: false,
        }}
        total={total}
        isLoading={isLoading}
        isLoadingMore={isLoadingMore}
        filter={filter}
        onPagination={onPagination}
        paginationLimit={HANDBOOK_SHOW_MORE_LIMIT}
        // Не показываем кнопки добавления работ в режиме просмотра по Атрибутам тк непонятно, в какой подраздел добавлять работу
        postfix={!isLoading && !segment && <CreateHandbookTemplateExpenditure subSectionId={subSectionId!} />}
      />
      {isLoadingApplyEditings && <TemplateBlurLoader text={TEMPLATE_APPLY_EDITINGS_LOADER_TEXT} />}
    </>
  );
};

export default HandBooksTemplateExpenditures;
